import { API } from "aws-amplify";


const index = async (params) => {
  let myInit = { // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: params
  };
  let items = await API.get("InasakuAPI", "/inasaku/paddy-fields", myInit);

  return items;
};

const show = async (params) => {
  let myInit = { // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: params
  };
  let items = await API.get("InasakuAPI", "/inasaku/paddy-fields", myInit);

  return items;
};

const bulkCreate = async (params) => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };
  let res = await API.post("InasakuAPI", "/inasaku/paddy-fields", myInit);

  return res;
};

const update = (params) => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params, // replace this with attributes you need
    },
    headers: {} // OPTIONAL
  };

  let res = API.put("InasakuAPI", `/inasaku/paddy-fields`, myInit);

  return res;
};

const del = (params) => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params, // replace this with attributes you need
    },
    headers: {} // OPTIONAL
  };

  let res = API.del("InasakuAPI", `/inasaku/paddy-fields`, myInit);

  return res;
};

export default {
  index: index,
  show: show,
  bulkCreate: bulkCreate,
  update: update,
  del: del,
};
